import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { Form, Input, Button, Typography, Tag } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

import HttpRequest from '../../../../../utils/HttpRequest';
import Notification from "../../../../../utils/Notification";
import SymptomsQueryTags from '../SymptomsQueryTags/SymptomsQueryTags';
import PageNotFound from '../../../../Authentication/components/PageNotFound/PageNotFound';

import CheckCircleIcon from "../../../../../assets/icons/check-circle.png";
import bgImg from '../../../../../assets/icons/chart-colored-bg.png'
import CustomIcon from '../../../../../utils/components/CustomIcon/CustomIcon';

import './SubmitRequest.css'
import ConstantMessages from '../../../../../utils/Strings';

const { Title } = Typography;
const { TextArea } = Input;
const notification = new Notification();

const SubmitRequestComponent = (props) => {
  // const { getFieldDecorator } = props.form;
  const location = useLocation()
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [searchRecord, setSearchRecord] = useState(null)
  const [caseVersion, setCaseVersion] = useState(null)
  const [saveCaseAndSubmitRequest, setSaveCaseAndSubmitRequest] = useState(false)
  const urlQueryParams = new URLSearchParams(location.search);

  const fieldsConfig = {
    email: {
      rules: [
        { required: true, whitespace: true, message: ConstantMessages.emailAddressRequired },
        { type: 'email', message: ConstantMessages.enterValidEmailAddress },
      ],
    },
    name: {
      rules: [
        { required: true, whitespace: true, message: 'Please enter name' },
        { max: 50, message: 'Maximum 50 characters allowed' }
      ]
    },
    practiceName: {
      rules: [
        { required: true, whitespace: true, message: 'Please enter practice name' },
        { max: 255, message: 'Maximum 255 characters allowed' }
      ]
    },
    note: {
      rules: [
        { max: 1024, message: 'Maximum 1024 characters allowed' }
      ]
    },
    caseNumber: {
      rules: [
        { required: true, whitespace: true, message: 'Please enter case number' },
        { max: 255, message: 'Maximum 255 characters allowed' }
      ]
    },
  };

  useEffect(() => {
    const caseVersionId = urlQueryParams.get('caseVersionId')
    if (!caseVersionId) return

    setLoading(true)
    fetchCaseVersion(caseVersionId).then((data) => {
      setCaseVersion(data)
    }).finally(() => setLoading(false))
  }, [])

  useEffect(() => {
    const searchRecordId = urlQueryParams.get('searchRecordId')
    if (!searchRecordId) return

    setLoading(true)
    fetchSearchHistory(searchRecordId).then((data) => {
      setSaveCaseAndSubmitRequest(true)
      setSearchRecord(data)
    }).finally(() => setLoading(false))
  }, [])

  const fetchCaseVersion = async (id) => {
    const res = await new HttpRequest(null, `/caseVersions/${id}`, 'get').send()
    return res.data.data
  }

  const fetchSearchHistory = async (id) => {
    const res = await new HttpRequest(null, `/searchHistory/${id}`, 'get').send()
    return res.data.data
  }

  const submitRequest = async (id, data) => {
    const res = await new HttpRequest(null, `/caseVersions/${id}/requestTest`, 'post', data).send()
    return res.data.data
  }

  const createCase = async ({ searchHistoryId, caseNumber }) => {
    const data = {
      searchHistoryId,
      "nickName": caseNumber,
      "queryType": "Regions of homozygosity",
      "genomeAssembly": "hg19",
      "locationUnit": "BASE",
      "notes": "",
      "genes": [],
      "fragments": [],
      "technology": "UNKNOWN",
      "makePaymentRequest": false
    }
    const res = await new HttpRequest(null, '/cases', 'post', data).send()
    return res.data.data
  }

  const handleSubmit = async (values) => {
    // e.preventDefault(); // Prevent default form submission
    // props.form.validateFields(async (err, values) => {
      // if (!err) {
        if (saveCaseAndSubmitRequest) {
          const caseObj = await createCase({
            searchHistoryId: searchRecord.id,
            caseNumber: values.caseNumber,
          })
          await submitRequest(caseObj.caseVersion.id, values)
        } else {
          await submitRequest(caseVersion.id, values)
        }
        // reset form fields
        // props.form.resetFields();
        notification.show('info', 'Request Submitted', 'Request is submitted successfully!');
        setTimeout(() => {
          history.goBack()
        }, 300)
      // }
    // });
  }

  const Tags = useMemo(() => {
    if (!searchRecord && !caseVersion) return null

    const { queryJSON, ethnicity, age, gender } = searchRecord || caseVersion.SearchHistory

    return (
      <div className="flex-vertical-gap-2">
        {caseVersion && <Title level={3} style={{ margin: 0 }}>{caseVersion.Case.nickName}</Title>}
        <div className="custom-tag-container">
          <Tag className="custom-tag">{ethnicity}</Tag>
          <Tag className="custom-tag">{age}</Tag>
          <Tag className="custom-tag">{gender}</Tag>
        </div>
        <SymptomsQueryTags node={queryJSON} />
      </div>
    )
  }, [caseVersion, searchRecord])

  if (!loading && !caseVersion && !searchRecord) {
    return <PageNotFound />
  }

  return (
    <>
    <div className="margin-bottom-4">
      <Button type="link" onClick={() => history.goBack() }>
        <ArrowLeftOutlined />
        Go Back
      </Button>
    </div>
    <div className="submit-request-form-wrapper">
      <div className="submit-request-form">
        <div className="gs-theme__container">
          <div id="submit-request-info-div" className="position-relative">
            <img src={bgImg} alt="bg-img" className="position-absolute-top-right" />
            <div id="submit-request-logo" className="gs-theme__icon-frame">
              <CustomIcon name="UserStory" width={40} height={40} color="#FFFFFF" />
              {/* <img src={CheckCircleIcon} alt='Application Logo' style={{ height: '40px', width: '40px' }} /> */}
            </div>
            <Title style={{ margin: 0, color: 'white' }} level={2}>GENA Test</Title>
          </div>
          <div style={{ padding: '24px', borderBottom: '1px solid var(--Neutral-Structure-300, #D0CDC8)' }}>{Tags}</div>
          <div style={{ padding: '24px' }}>
            <Form form={props.form} layout="vertical" onFinish={handleSubmit} style={{ padding: '0px', backgroundColor: 'transparent' }} initialValues={{
              practiceName: props?.loggedInUser?.organization?.name ?? ''
            }}>
              <Form.Item label="Name" name="name" rules={fieldsConfig.name.rules}>
                <Input placeholder="Enter name" />
              </Form.Item>
              <Form.Item label="Contact Email" name="email" rules={fieldsConfig.email.rules}>
                <Input placeholder="Enter email" />
              </Form.Item>
              <Form.Item label="Practice Name" name="practiceName" rules={fieldsConfig.practiceName.rules}>
                <Input placeholder="Enter practice name" />
              </Form.Item>
              <Form.Item label="Note (Optional)" name="note" rules={fieldsConfig.note.rules}>
                <TextArea rows={4} placeholder="Enter note" />
              </Form.Item>
              {saveCaseAndSubmitRequest ?
              <>
                <Form.Item label="Case Number" name="caseNumber" rules={fieldsConfig.caseNumber.rules}>
                  <Input placeholder="Enter case number" />
                </Form.Item>
                <Form.Item>
                  <Button className="margin-top-2" type="primary" htmlType="submit" block>
                    {'Save Case & Submit Request'}
                    <CustomIcon name="Mail" />
                  </Button>
                </Form.Item>
              </> :
              <>
                <Form.Item>
                  <Button className="margin-top-2" type="primary" htmlType="submit" block>
                    Submit Request
                    <CustomIcon name="Mail" />
                  </Button>
                </Form.Item>
              </>}
            </Form>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

let SubmitRequest = (props) => {
  const [form] = Form.useForm();
  return <SubmitRequestComponent form={form} {...props} />;
};

const mapStateToProps = (state) => {
  return {
    loggedInUser: state.auth.loggedInUser
  }
};

const mapDispatchToProps = (dispatch) => {
  return {}
};

SubmitRequest = connect(
  mapStateToProps,
  mapDispatchToProps
)(SubmitRequest);

export default SubmitRequest;
